import './App.css';
import Header from './components/header';
import About from './components/about';
import Lessons from './components/lessons';
import Home from './components/home';
import { Route, Routes } from 'react-router';
import LessonPage from './components/lessonPage';
import StudentWork from './components/studentWork';

function App() {
  return (
    <div className="App App-header">
      <Header/>
      <Routes>
        <Route path="*/" element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="home" element={<Home />} />
        <Route path="lessons" element={<Lessons />} />
        <Route path="about" element={<About />} />
        <Route path="lessons/:id" element={<LessonPage />} />
        <Route path="studentwork" element={<StudentWork />}></Route>
      </Routes>
      <div className='footer' />
    </div>
  );
}

export default App;
